// extracted by mini-css-extract-plugin
export var btn = "footerFull-module--btn--e79ce";
export var buttonMd = "footerFull-module--button-md--93b62";
export var fBtn = "footerFull-module--f-btn--2b413";
export var footer = "footerFull-module--footer--6f63b";
export var footerMedium = "footerFull-module--footerMedium--fe33b";
export var footerMedium__text = "footerFull-module--footerMedium__text--23696";
export var footer__blockAbout = "footerFull-module--footer__block-about--ebe7a";
export var footer__blockLink1 = "footerFull-module--footer__block-link-1--79360";
export var footer__blockLink2 = "footerFull-module--footer__block-link-2--86e40";
export var footer__blockPartnership = "footerFull-module--footer__block-partnership--816f4";
export var footer__box = "footerFull-module--footer__box--a6d69";
export var footer__formSection = "footerFull-module--footer__form-section--380a5";
export var footer__info = "footerFull-module--footer__info--f676e";
export var footer__license = "footerFull-module--footer__license--a6c39";
export var footer__licenseInfo = "footerFull-module--footer__license-info--ace7d";
export var footer__list = "footerFull-module--footer__list--501fb";
export var footer__listSection = "footerFull-module--footer__list-section--06fd2";
export var footer__listSectionListTitle = "footerFull-module--footer__list-section--list-title--32734";
export var footer__listSectionTitle = "footerFull-module--footer__list-section--title--3ed2f";
export var footer__logo = "footerFull-module--footer__logo--b11ac";
export var footer__mainInfo = "footerFull-module--footer__main-info--4b214";
export var footer__rights = "footerFull-module--footer__rights--cc1fa";
export var footer__shareBtn = "footerFull-module--footer__share-btn--ca7f9";
export var footer__shareText = "footerFull-module--footer__share-text--d6916";
export var footer__siteMap = "footerFull-module--footer__site-map--e4dc9";
export var footer__social = "footerFull-module--footer__social--cdd34";
export var footer__tel = "footerFull-module--footer__tel--8340a";
export var tgTrainings = "footerFull-module--tg-trainings--15cdd";
export var yaShare2__badge = "footerFull-module--ya-share2__badge--60dfb";
export var yaShare2__container = "footerFull-module--ya-share2__container--16e80";
export var yaShare2__container_colorScheme_blackwhite = "footerFull-module--ya-share2__container_color-scheme_blackwhite--5b0d5";
export var yaShare2__container_shape_round = "footerFull-module--ya-share2__container_shape_round--6308b";
export var yaShare2__container_size_s = "footerFull-module--ya-share2__container_size_s--53a1a";
export var yaShare2__icon = "footerFull-module--ya-share2__icon--d8dcb";
export var yaShare2__icon_copy = "footerFull-module--ya-share2__icon_copy--72a44";
export var yaShare2__icon_messengerContact = "footerFull-module--ya-share2__icon_messenger-contact--4f524";
export var yaShare2__icon_more = "footerFull-module--ya-share2__icon_more--c0a89";
export var yaShare2__item = "footerFull-module--ya-share2__item--a025c";
export var yaShare2__list = "footerFull-module--ya-share2__list--f3c9d";
export var yaShare2__list_direction_horizontal = "footerFull-module--ya-share2__list_direction_horizontal--41590";
export var yaShare2__mobilePopupBadge = "footerFull-module--ya-share2__mobile-popup-badge--ffadb";